import {AccountGroupsService} from '../services/user-account-groups.service';
import {UserAccountService} from '../services/user-account.service';

import {IUsersAndGroupsSearchResult} from '../../shared/types/user-account-groups.types';

import {isFulfilled} from '../../shared/helpers/checkAllSettled';
import {filterDivider} from '../../shared/helpers/filterDivider';
import {getFullName} from '../../shared/helpers/getFullName';

import {ISelectOption} from './option.type';
import {IUserAccount, TypeAccountRoles} from '../../shared/types/user-account.types';

export interface IWorkerSelectOption<T> extends Pick<ISelectOption, 'label'> {
  value: T;
  photo: string | null;
}

export const getUserPhoto = async (id: number) => {
  // TODO: отключает фото до лучших времен
  return null;

  if (!id) return null;

  const res = await UserAccountService.getUserPhoto(id);

  const data = await res.blob();

  const url = URL.createObjectURL(data);

  return url;
};

//todo: будет переписано
export const searchWorkersStrategy = async (str: string): Promise<IWorkerSelectOption<IUserAccount>[]> => {
  const {data} = await UserAccountService.getAll({
    pageable: {
      size: 25,
      page: 0,
    },
    spec: {
      roles: [TypeAccountRoles.WORKER],
      isActive: true,
      ...(str ? {fio: str.trim()} : {}),
    },
  });

  if (data.content.length) {
    const photoUrls = await Promise.allSettled(data.content.map((i) => getUserPhoto(i.id)));

    return photoUrls.map((item, index) => {
      const name = getFullName(data.content[index]);

      return {
        value: data.content[index],
        label: name,
        photo: isFulfilled(item) ? item.value : null,
      };
    });
  }

  return [];
};

export const searchWorkersForFilterStrategy = async (str: string): Promise<IWorkerSelectOption<string>[]> => {
  const {data} = await UserAccountService.getAll({
    pageable: {
      size: 25,
      page: 0,
    },
    spec: {
      roles: [TypeAccountRoles.WORKER],
      isActive: true,
      ...(str ? {fio: str.trim()} : {}),
    },
  });

  if (data.content.length) {
    const photoUrls = await Promise.allSettled(data.content.map((i) => getUserPhoto(i.id)));

    return photoUrls.map((item, index) => {
      const name = getFullName(data.content[index]);

      return {
        value: data.content[index].uid,
        label: name,
        photo: isFulfilled(item) ? item.value : null,
      };
    });
  }

  return [];
};

export const searchWorkersAndGroupsStrategy = async (
  str: string,
): Promise<IWorkerSelectOption<IUsersAndGroupsSearchResult>[]> => {
  const res = await AccountGroupsService.usersOrGroups<IUsersAndGroupsSearchResult[]>({
    roles: [TypeAccountRoles.WORKER],
    name: str.trim(),
  });

  if (res.data.length) {
    const filtered = filterDivider<IUsersAndGroupsSearchResult>(res.data, (i) => i.type !== 'GROUP');
    const photoUrls = await Promise.allSettled(filtered[0].map((i) => getUserPhoto(i.id)));

    return photoUrls
      .map((item, index) => {
        const nameArr = filtered[0][index].name.split(' ');

        return {
          value: filtered[0][index],
          label:
            nameArr.length === 2
              ? `${nameArr[1]} ${nameArr[0].charAt(0)}.`
              : `${nameArr[2]} ${nameArr[0].charAt(0)}.${nameArr[1].charAt(0)}.`,
          photo: isFulfilled(item) ? item.value : null,
        };
      })
      .concat(
        filtered[1].map((item, index) => {
          return {
            value: filtered[1][index],
            label: filtered[1][index].name,
            photo: null,
          };
        }),
      );
  }

  return [];
};
